import React from 'react';

function ThemeInput({ theme, setTheme, style, setStyle, onEnterPress }) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && theme.trim() && style.trim()) {
      onEnterPress();
    }
  };

  return (
    <div className="mb-4 w-full">
      <input
        type="text"
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Entrez un thème pour votre rap"
        className="rap-input w-full"
      />
      <select
        value={style}
        onChange={(e) => setStyle(e.target.value)}
        className="rap-input w-full mt-2"
      >
        <option value="">Choisissez un style</option>
        <option value="rap conscient">Rap conscient</option>
        <option value="rap hardcore">Rap hardcore</option>
        <option value="rap melodique">Rap mélodique</option>
        <option value="rap old school">Rap old school</option>
        <option value="trap">Trap</option>
        <option value="cloud rap">Cloud rap</option>
      </select>
    </div>
  );
}

export default ThemeInput;